import { DialogContent, DialogTitle, DialogActions } from "@mui/material";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import styles from "./index.module.scss";
import UKDialog from "@/common-components-src/components/UKDialog/index";
import CommonButton from "../commonButton";

interface ageTipsModalProps {
  modalInfo:
    | {
        title: string;
        content: string;
      }
    | undefined;
  isOpen: boolean;
  closeHandler: () => void;
}

const ageTipsModal: React.FC<ageTipsModalProps> = observer(({ modalInfo, isOpen, closeHandler }) => {
  const { t } = useTranslation();

  return (
    <UKDialog
      open={isOpen}
      onClose={closeHandler}
      showCloseBtn={true}
      className={styles.repayOrderModal}
      sx={{
        "& .MuiDialog-paper": {
          width: "520px", // 设置自定义宽度
        },
      }}
    >
      <DialogTitle>{modalInfo?.title}</DialogTitle>
      <DialogContent
        sx={{
          maxHeight: "570px",
          paddingBottom: 0,
        }}
      >
        <div
          className={styles.tipContent}
          dangerouslySetInnerHTML={{
            __html: modalInfo?.content || "",
          }}
        ></div>
      </DialogContent>
      <DialogActions
        sx={{
          paddingTop: "20px",
        }}
      >
        <CommonButton variant="contained" onClick={closeHandler}>
          {t("common.btnText.ok")}
        </CommonButton>
      </DialogActions>
    </UKDialog>
  );
});

export default ageTipsModal;
